import { NextPage } from 'next'
import { PRODUCT_DISCLOSURE_LINK } from '../common/config'
import React from 'react'


export const ProductDisclosure: NextPage = () => {

    return (
        <iframe
        title='Product Disclosure'
        src={PRODUCT_DISCLOSURE_LINK}
        style={{ width: '100%', height: '100vh' }}
        />
      )

}